import React, { useState, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {usersByRole} from 'network/ApiAxios'
import Select from 'react-select';

function UserByRoleSelectNoMadal(props) {
    useEffect(() => {
        retriveAllUser()
    }, []);
    
    const [users, setUsers] = useState('');
    const [options, setOptions] = useState();

    const retriveAllUser= async()=>{
            const resp = props.role ? await usersByRole(props.role) : await usersByRole()
            if(resp.data){
              setUsers(resp.data)
              const opts = resp.data.map((user)=>{
                return {label:user.name, value: user._id}
                })
              setOptions(opts)
            }
    }
    
  return (
    <Select onChange={(e)=>{props.handler(e.value)}} options={options} />
  )
}

export default UserByRoleSelectNoMadal